module.exports = __webpack_public_path__ + "static/kolenyova-7f1f4bfdb6ef3c34116980803432c836.jpg";